<template><div class="view">

	<fetching-content v-if="is_fetching_content" />
	<error-404 v-if="!model && !is_fetching_content" />	

	<left-menu-model v-if="model" />

	<main v-if="model">
		
		<blocks v-if="!editing_blocks" :blocks="book_blocks" :metadata="{model,book}" />
		
		<block-editor v-if="editing_blocks" :blocks="book_blocks" :route_name="$route.name" :model="model" :book_slug="book" @updated="blocksUpdated()" @onexit="blockEditorOnExit()" />
		
		<p v-if="( !book_blocks || !book_blocks.length ) && !editing_blocks && loggedin_user" class="nothing-blocks">
			No content. You are seeing this only because you are logged in as admin.
		</p>

	</main>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'
import LeftMenuModel from '.././views/LeftMenuModel'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		Blocks, 
		BlockEditor, 
		LeftMenuModel,
	},

	data(){ return {


	}},

	computed: {

		slug(){ return this.route.params.slug },

		book(){
			var book = this.route.params.book
			if( !book ) book = 'portfolio'
			return book
		},

		model(){ return this.$store.state.loaded_model },

		book_blocks(){
			if( !this.book ) return
			if( !this.model ) return			
			if( !this.model.books ) return

			var book_slug = this.book
			if( this.book == 'full-book' ) book_slug = 'portfolio'

			if( !this.model.books[book_slug] ) return
			
			var blocks = this.model.books[book_slug]
			
			if( !this.editing_blocks ) {

				if( this.book == 'portfolio' ) blocks = blocks.slice( 0, this.$store.state.blocks_max.model.portfolio )
				if( this.book == 'runway' ) blocks = blocks.slice( 0, this.$store.state.blocks_max.model.runway )
				if( this.book == 'polaroids') blocks = blocks.slice( 0, this.$store.state.blocks_max.model.polaroids )

				if( this.book != 'full-book' ) blocks = helpers.blocks_filter_capbelowblock(blocks)
				blocks = helpers.blocks_filter_nohideblocks(blocks)

				//if( this.book == 'full-book' ) blocks = helpers.rearrange_blocks( '1-1', blocks )

			}
			
			
			return blocks
		},

	},

	methods: {

//---------------------------------------------------------------------------------------

		load_model(){
			
			var _this = this

			this.$store.commit('set_loaded_model', undefined )
			
			this.fetch( 'get_model', { slug:this.slug }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.model ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_model', output.data.model )
				_this.setDocumentTitle( output.data.model.full_name )				
				_this.checkIfEmptyPortfolioBook()
				setTimeout(function(){
					window.prerenderReady = true
				}, 0)

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})

		},

//---------------------------------------------------------------------------------------

		blocksUpdated(){
			//this.load_model()
		},

//---------------------------------------------------------------------------------------

		blockEditorOnExit(){
			console.log('block editor exit')
			this.load_model()
		},

//---------------------------------------------------------------------------------------

		checkIfEmptyPortfolioBook(){			
			if( this.book_blocks && this.book_blocks.length )  return // do nothing
				
			var books = this.model.books
			if( books.portfolio && books.portfolio.length ) 	{ this.$router.push( '/model/' +this.model.slug ); return }
			if( books.polaroids && books.polaroids.length ) 	{ this.$router.push( '/model/' +this.model.slug+ '/polaroids' ); return }
			if( books.runway && books.runway.length ) 			{ this.$router.push( '/model/' +this.model.slug+ '/runway' ); return }

		},

//---------------------------------------------------------------------------------------

	},

	watch: {
		'$route' (to, from) {
			
			//this.load_model()

			//window.scrollTo( 0, 0 )


		}
	},
	
	mounted(){
		this.load_model()
	},

	created(){
	},

}
</script>



// WEBPACK FOOTER //
// src/views/ModelSingle.vue